export class RefObject {
  constructor(
    public readonly id: number) {}
}
